import { Component } from '@angular/core';
import { nodeType } from 'src/app/core/constants/constants';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';
import { SubSink } from 'subsink';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-source-node',
  templateUrl: './source-node.component.html',
  styleUrls: ['./source-node.component.scss']
})
export class SourceNodeComponent {

  public lastSelectedNode!: HTMLElement;
  public lastSelectedNodeType!: string;
  private subs: SubSink = new SubSink();
  public nodeTypes: any = nodeType;
  public gridData:any = [];
  public sheetName:{key:string} = this._flowBuilder.sheetName;
  sourceType:any='dataset';
  sheetNames!: any[];
  tooltipDiv:boolean = false
  selectedCity: any;
  cities = [
    {id: 1, name: 'String'},
    {id: 2, name: 'Int'},
    {id: 2, name: 'Boolean'},
    {id: 2, name: 'Varchar'},
    {id: 2, name: 'Blob'},
  ];
  clickInput=false;

  connectorTypes=[
    {
      name:'GDP Insights Oracle',
      img:'assets/images/svg/connector.svg',
      isToolTipShow:false
    },
    {
      name:'SCAD IFP Database',
      img:'assets/images/svg/scad-ifp.svg',
      isToolTipShow:false
    },
  ]


  constructor(public _flowBuilder: FlowBuilderService) {
    this.subs.add(
      this._flowBuilder.nodeDoubleClick$.subscribe((res: string | any) => {
        this.onNodeDoubleClick(res.type, res.element);
      }
      ));
  }


  onFileChange(env: any, type: string) {
    const activeNode = this._flowBuilder.activeNode;
    if (!activeNode.connection) {
      activeNode.connection = {};
    }
    let files: any[] = [];
    switch (type) {
      case 'drop':
        files = env;
        break;

      case 'click':
        files = env.files
        break;

      default:
        break;
    }

    let fileTypes = ['.xls', '.xlsx', 'application/pdf', '.pdf', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', '.csv', '.doc', '.docx', '.xml', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
   let invC = true
    for (let i = 0; i < files?.length; i++) {
      const element = files[i];
      if (!fileTypes.includes(element.type)) {
        invC = false;
      }
    }
    if (!invC) {
      alert('Invalid doc');
      return;
    }
    
    this._flowBuilder.fileType = (String(files[0].name).split('.')[String(files[0].name).split('.').length-1] ==='xlsx' || String(files[0].name).split('.')[String(files[0].name).split('.').length-1] ==='xls') ? 'excel':String(files[0].name).split('.')[String(files[0].name).split('.').length-1];
    activeNode.connection.file = files[0];
    activeNode.sourceFile = files[0]?.name;
    this.getGridData(files[0]);
    this.saveFileUpload(activeNode);
  }


  fileHeaders(workSheet: XLSX.WorkSheet) {
    const headers = [];
    const range = XLSX.utils.decode_range(workSheet[this._flowBuilder.constFileUpload['ref']]);
    let column: string | number;
    const row = range.s.r;
    for (column = range.s.c; column <= range.e.c; ++column) {
      const cell = workSheet[XLSX.utils.encode_cell({ c: column, r: row })];
      let header = this._flowBuilder.constFileUpload['unknown'] + column;
      if (cell?.t) {
        header = cell.v;
      }
      headers.push(header);
    }
    return headers;
  }



  getGridData(files:any){
    const activeNode = this._flowBuilder.activeNode;
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(files);
    reader.onload = (eventOnLoad: any) => {
      const binaryString = eventOnLoad.target?.result;

      const workBook: XLSX.WorkBook = XLSX.read(binaryString, { type: 'binary'});
      let workSheetName: string;

      this.sheetName.key = workBook.SheetNames[0];
      this._flowBuilder.sheetName = this?.sheetName;
      workSheetName = workBook.SheetNames[0];

      workSheetName = this.sheetName?.key;
      this.sheetNames = [];
      workBook.SheetNames.map((sheetName:any) => {
        this.sheetNames.push({ key: sheetName });
      });
      this._flowBuilder.sheetNames = this?.sheetNames;
      activeNode.sourceSheet = this?.sheetName?.key;

      const workSheet: XLSX.WorkSheet = workBook.Sheets[workSheetName];
      const previewData = XLSX.utils.sheet_to_json(workSheet, { defval: null, raw: false });

      const headers = this.fileHeaders(workSheet);
      previewData.forEach((element:any, index:number) => {
        this._flowBuilder.previewDataValues[index] = Object.values(element);
      });

      const gridData = previewData?.map((item:any) => {
        const gridRecord:any = {};
        Object.values(item).forEach((value:any, index:number) => {
          gridRecord[headers[index]] = value;
        });
        return gridRecord;
      });
      this._flowBuilder.gridDataPreview = gridData;
      activeNode.connection.gridData = gridData;
      this._flowBuilder.sampleSize = gridData.length;
    }

  }



  saveFileUpload(activeNode:any) {
    this._flowBuilder.activeNode.connection.name = activeNode?.connection?.file?.name;
    this._flowBuilder.activeNode.sourceFile = activeNode?.connection?.file?.name;
  }


  onNodeDoubleClick(type: string, element: HTMLElement) {
    this._flowBuilder.clickFlag = -1;
    this.lastSelectedNode = element;
    this.lastSelectedNodeType = type;

  }


}
